module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "esign"
  }, [_c('div', {
    staticClass: "esign-box"
  }, [_c('vue-esign', {
    ref: "esign",
    staticClass: "sign1",
    attrs: {
      "id": "esignId",
      "width": 1,
      "height": 1,
      "isCrop": _vm.isCrop,
      "lineWidth": _vm.lineWidth,
      "lineColor": _vm.lineColor,
      "bgColor": _vm.bgColor
    },
    on: {
      "update:bgColor": function($event) {
        _vm.bgColor = $event
      },
      "update:bg-color": function($event) {
        _vm.bgColor = $event
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_c('vue-qr', {
    ref: "qrId",
    attrs: {
      "text": _vm.text,
      "size": 200
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "padding-top": "20px",
      "font-size": "20px",
      "border": "1px solid red",
      "width": "440px",
      "height": "180px",
      "margin-left": "-10px",
      "margin-top": "18px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "conf0",
      "hidden": _vm.resultImg == '',
      "src": _vm.resultImg
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "45px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleGenerate
    }
  }, [_vm._v(" 确认签名 ")]), _c('br'), _c('br')], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "padding-top": "20px",
      "font-size": "20px"
    }
  }, [_vm._v("微信"), _c('br'), _vm._v("扫一"), _c('br'), _vm._v("扫,"), _c('br'), _vm._v("关注"), _c('br'), _vm._v("公众"), _c('br'), _vm._v("号")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "200px",
      "height": "200px"
    },
    attrs: {
      "src": require("../assets/公众号二维码.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left",
      "padding-top": "20px",
      "font-size": "20px"
    }
  }, [_vm._v("  微信"), _c('br'), _vm._v("扫一"), _c('br'), _vm._v("扫,"), _c('br'), _vm._v("在线"), _c('br'), _vm._v("同步"), _c('br'), _vm._v("签名")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "padding-left": "10px",
      "font-size": "20px",
      "width": "400px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" 注意：")]), _vm._v("\r\n      请在微信扫码签名前关注 \r\n       微信公众号，点击【我的】-\r\n       【客户注册】进行注册，确认\r\n       签名有效性，同时签名后可在\r\n       公众号【委托管理】【进度查询】查询委托进度\r\n       ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13dbb200"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/esign.vue
// module id = 1191
// module chunks = 10